import React, {Component} from 'react';
import Script from 'react-load-script';
import {Loader} from "../Common/Loader";
import Donate from "./Donate";

class DonateMobile extends Component {

    render() {
        return (
            <Donate/>
        );

    }
}

export default DonateMobile;



// WEBPACK FOOTER //
// ./components/Donate/DonateMobile.js